import {
  SET_LEADS,
  UPDATE_LEAD_STATUS,
  UPDATE_LEAD_TRANSCRIPT,
  SET_LOADING,
} from "./actions";

const initialState = {
  leads: [],
  isLoading: false,
};

const outboundCallsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEADS:
      return {
        ...state,
        leads: action.payload,
      };

    case UPDATE_LEAD_STATUS:
      return {
        ...state,
        leads: state.leads.map((lead) =>
          lead.id === action.payload.leadId
            ? {
                ...lead,
                status: action.payload.status,
                vapiCallId: action.payload.vapiCallId,
                callStartedAt: action.payload.callStartedAt,
                callEndedAt: action.payload.callEndedAt,
              }
            : lead
        ),
      };

    case UPDATE_LEAD_TRANSCRIPT:
      return {
        ...state,
        leads: state.leads.map((lead) =>
          lead.id === action.payload.leadId
            ? {
                ...lead,
                transcript: action.payload.transcript,
                summary: action.payload.summary,
                recordingUrl: action.payload.recordingUrl,
                lastCallDuration: action.payload.duration,
              }
            : lead
        ),
      };

    case SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
};

export default outboundCallsReducer;
